import type { JSX } from 'react'

export const ForwardSolidIcon = (): JSX.Element => (
  <use href='#forwardSolidIcon' height='100%' width='100%' />
)
